export function seo(data = {}) {
	if(data.title.includes("undefined") ){
		data.title = "Loading...";
		document.title = "Loading...";
	} else {
		data.title = data.title;
		document.title = data.title;
	}
}
